import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { t } from "i18next";
import SunburstChart from "../../../components/Charts/SunBurstChart/SunBurst";
import "./JourneysView.css";
import { Link, useParams } from "react-router-dom";
import centralApi from "../../../services/centralApi";
import CustomBreadCrumb from "../../../components/CustomBreadCrumb/CustomBreadCrumb";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CreateFunnelModal from "./CreateFunnelModal";
import Spinner from "../../../components/Spinner/Spinner";
import { API_ENDPOINTS, ROUTES } from "utils/constants";
import PageLayout from "layout/PageLayout/PageLayout";

const JourneysView: React.FC = () => {
  interface RootState {
    loginUser: {
      data: {
        api_key: string;
      };
    };
  }
  interface ActiveAppState {
    activeApp: {
      appName: string;
      appId: string;
    };
  }
  const { id } = useParams();
  const loginUser = useSelector((state: RootState) => state.loginUser);
  const { appId } = useSelector((state: ActiveAppState) => state.activeApp);

  const api_key = loginUser.data.api_key;
  const [tableData, setTableData] = useState([]); // State variable to store table data
  const [modal, setModal] = useState(false);

  const [journeysChartData, setJourneysChartData] = useState<any>([]);
  const [isTableVisible, setTableVisible] = useState(false);

  const [loading, setLoading] = useState(false);

  async function getJourney() {
    const payload = {
      app_id: appId,
      api_key: api_key,
      id: id,
    };

    try {
      setLoading(true);
      const data = await centralApi("GET", API_ENDPOINTS.GET_USER_JOURNEY_URL, null, payload);
      setJourneysChartData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }
  const handleTableData = useCallback((data: any) => {
    // Process and use the data received from the SunburstChart
    setTableData(data);
  }, []);
  interface TableDataItem {
    name: string;
  }
  const eventNames: string[] = tableData.map(
    (item: TableDataItem | undefined) => item?.name || ""
  );

  // const eventNames = tableData.map((item: string) => item?.name);

  const openModal = useCallback(() => {
    setModal(true); // Toggles the modal state
  }, []);

  const columns = [
    {
      title: t("journeyLabelName"),
      dataIndex: "name",
      key: "name",
    },
    {
      title:  t("journeyLabelValue"),
      dataIndex: "value",
      key: "value",
    },
    {
      title:  t("journeyLabelPercentage"),
      dataIndex: "percentage",
      key: "percentage",
    },
  ];
  const handleShowTable = useCallback((isHovered: boolean) => {
    setTableVisible(isHovered); // Set to false when there are no hovered points
  }, []);

  useEffect(() => {
    getJourney();
  }, [id, api_key, appId]);
  return (
    <PageLayout
    title={`${t("journeyLabel")} | ${t("viewLabel")}`}
    className="journey-view-container"
    topLeftItem={
      <CustomBreadCrumb
      items={[
        {
          title: (
            <Link to={ROUTES.DASHBOARD_JOURNEYS}>{t("journeyLabel")}</Link>
          ),
        },
        {
          title: <span>{t("viewLabel")}</span>,
        },
      ]}
    />
    }
    >
      <div >
        {loading ? (
          <Spinner />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center  p-2">
              <strong>{journeysChartData?.journeyName}</strong>
            </div>

            <div className="px-sm-3 px-1" journey-chart-wrapper>
              <SunburstChart
                journeyData={journeysChartData?.paths}
                onTableData={handleTableData}
                openModal={openModal}
                showTable={handleShowTable}
                isTableVisible={isTableVisible}
                height = {800}
              />
              {/* <MyChart/> */}
              <div className="journey-table-overlay">
                {isTableVisible && ( // Render the table only when isTableVisible is true
                  <CustomTable
                    columns={columns}
                    dataSource={tableData}
                    pagination={false}
                  />
                )}
                <CreateFunnelModal
                  openModal={modal}
                  setModalOpen={setModal}
                  eventNames={eventNames}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </PageLayout>
  );
};

export default JourneysView;
